// src/components/ProtectedRoute.jsx
import React from 'react';
import {isLoggedIn} from '../utils/auth';
import {Navigate, useLocation} from 'react-router-dom';

const ProtectedRoute = ({children}) => {
    const location = useLocation();

    // Если не залогинен — сразу редирект на /auth и запоминаем, откуда пришёл
    if (!isLoggedIn()) {
        return <Navigate to="/auth" replace state={{from: location}}/>;
    }

    return children;
};

export default ProtectedRoute;
